import { AppBox, AppText } from "../../../../../commons/components";
import { IFootballTeamManager } from "../../../../../commons/models/football/interface/i-football-team-manager";

interface TeamManagerRemoveProps {
  teamManager: IFootballTeamManager;
}
export default function TeamManagerRemovalInprogress({ teamManager }: TeamManagerRemoveProps) {
  return (
    <AppBox flexDirection="column" gap="sm">
      <AppText>
        Removing <strong>“{teamManager.fullName}”</strong> In Progress
      </AppText>
      <AppBox className="loader-line"></AppBox>
    </AppBox>
  );
}
